// src/components/customer/cart/CartSummary.jsx

import { useState } from "react";
import "../../../assets/css/customer/cart/CartSummary.css";
import { useCart } from "../../../context/CartContext";

const CartSummary = ({ onCheckout, selectedItems = [] }) => {
  const { discountAmount, couponCode, applyCoupon, removeCoupon } = useCart();

  const [couponInput, setCouponInput] = useState("");
  const [couponMessage, setCouponMessage] = useState("");

  // All cart items ka subtotal (selection nahi, saari items)
  const subtotal = selectedItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0,
  );

  const discountedSubtotal = Math.max(0, subtotal - discountAmount);
  const tax = Math.round(discountedSubtotal * 0.18);
  const grandTotal = discountedSubtotal + tax;

  const handleApplyCoupon = () => {
    if (!couponInput.trim()) {
      setCouponMessage("Please enter a coupon code");
      return;
    }
    const result = applyCoupon(couponInput);
    setCouponMessage(result.message);
    if (result.success) setCouponInput("");
  };

  const handleRemoveCoupon = () => {
    removeCoupon();
    setCouponMessage("");
  };

  return (
    <div className="cart-summary">
      <h2 className="summary-title">Order Summary</h2>

      {/* Item count */}
      <p className="summary-item-count">
        {selectedItems.length} {selectedItems.length === 1 ? "item" : "items"}{" "}
        in cart
      </p>

      {/* Price Breakdown */}
      <div className="summary-details">
        <div className="summary-row">
          <span>Subtotal</span>
          <span>Rs. {subtotal.toLocaleString()}</span>
        </div>

        {/* {discountAmount > 0 && (
          <div className="summary-row discount-row">
            <span>Discount ({couponCode})</span>
            <span>− Rs. {discountAmount.toLocaleString()}</span>
          </div>
        )} */}

        <div className="summary-row">
          <span>Tax (GST 18%)</span>
          <span>Rs. {tax.toLocaleString()}</span>
        </div>

        <div className="summary-row total-row">
          <span>Grand Total</span>
          <span>Rs. {grandTotal.toLocaleString()}</span>
        </div>
      </div>

      {/* Coupon Section */}
      {/* <div className="coupon-section">
        {!couponCode ? (
          <>
            <input
              type="text"
              className="coupon-input"
              placeholder="Enter coupon code"
              value={couponInput}
              onChange={(e) => setCouponInput(e.target.value.toUpperCase())}
            />
            <button className="coupon-btn" onClick={handleApplyCoupon}>
              Apply
            </button>
          </>
        ) : (
          <div className="applied-coupon">
            <span>✅ {couponCode} Applied</span>
            <button className="remove-coupon-btn" onClick={handleRemoveCoupon}>
              Remove
            </button>
          </div>
        )}
        {couponMessage && (
          <p
            className={`coupon-message ${couponMessage.includes("applied") ? "success" : "error"}`}
          >
            {couponMessage}
          </p>
        )}
      </div> */}

      {/* Checkout Button — always enabled jab items hain */}
      <button
        className="checkout-btn"
        onClick={onCheckout}
        disabled={selectedItems.length === 0}
      >
        Proceed to Checkout →
      </button>
    </div>
  );
};

export default CartSummary;
